import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, MapPin, Users } from 'lucide-react';
export function HeroSection() {
  return <section className="px-4 max-w-5xl mx-auto text-center mt-[-50px] mb-[-50px] space-y-[0px] pt-[10px] pb-[10px]" data-id="element-183">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="inline-flex items-center gap-2 bg-[#c9a961]/10 text-[#b8860b] px-4 py-1.5 rounded-full font-bold border border-[#c9a961]/30 mt-[0px] mb-[0px] text-[14px] shadow-sm" data-id="element-184">
        <span data-id="element-185">🤖</span> TU MANUAL DIGITAL™
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="md:text-7xl font-extrabold tracking-tight text-balance mt-[-5px] mb-[-5px] text-[28px] text-[#1a1611]" data-id="element-186">
        El sistema que convierte la IA en tu equipo de marketing
      </motion.h1>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="mb-8 space-y-[0px]" data-id="element-187"></motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.7,
      delay: 0.25
    }} className="flex flex-col items-center justify-center my-6" data-id="element-188">
        <img src="https://cdn.magicpatterns.com/uploads/vXfowFWetsfpf3mhPFPTka/ChatGPT_Image_12_may_2026__00_49_56-removebg-preview.png" alt="Megapack Negocio IA Listo - Mockup del producto" className="w-[62.5%] max-w-[17.5rem] md:max-w-sm drop-shadow-[0_20px_40px_rgba(201,169,97,0.3)] pt-[0px] pb-[0px] mt-[-20px] mb-[-20px]" data-id="element-189" />
        <p className="md:text-2xl text-[#1a1611] font-bold pt-[5px] pb-[5px] text-[16px]" data-id="element-190">
          Para emprendedoras y negocios de servicios
        </p>
        <p className="text-[#6b5d4f] font-medium pt-[0px] pb-[0px] mt-[0px] mb-[0px] text-[12px]" data-id="element-191">
          Contenido · Imágenes · Ventas · Todo listo para usar
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="grid grid-cols-3 gap-2 md:gap-3 text-xs md:text-sm font-bold text-[#6b5d4f] mt-[0px] mb-[0px] items-stretch justify-center pt-[10px] pb-[10px]" data-id="element-192">
        <div className="flex items-center justify-center gap-1 bg-white px-3 py-1.5 rounded-md border border-[#e8dfd0] whitespace-nowrap shadow-sm" data-id="element-193">
          <FileText size={14} className="text-[#c9a961]" data-id="element-194" /> 100% PDF
        </div>
        <div className="flex items-center justify-center gap-1 bg-white px-3 py-1.5 rounded-md border border-[#e8dfd0] whitespace-nowrap font-bold shadow-sm" data-id="element-195">
          <Zap size={14} className="text-[#c9a961]" data-id="element-196" /> Acceso al instante
        </div>
        <div className="flex items-center justify-center gap-1 bg-white px-3 py-1.5 rounded-md border border-[#e8dfd0] whitespace-nowrap shadow-sm" data-id="element-197">
          <Users size={14} className="text-[#c9a961]" data-id="element-198" /> Todos los rubros
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="flex flex-col items-center" data-id="element-199">
        <a href="#pricing" className="group relative inline-flex px-8 py-5 text-xl font-black text-[#0a0a0a] bg-[#c9a961] rounded-xl overflow-hidden transition-all hover:scale-105 hover:bg-[#d4af37] shadow-[0_10px_40px_rgba(201,169,97,0.4)] animate-pulse-slow w-full max-w-md gap-[0px] items-center justify-center pt-[10px] pb-[10px] pl-[0px] pr-[0px] mt-[0px] mb-[0px]" data-id="element-200">
          <span className="relative z-10 flex gap-[10px] items-center justify-center text-[18px] pt-[4px] pb-[4px]" data-id="element-201">
            → QUIERO MI MEGAPACK AHORA
          </span>
          <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-202" />
        </a>

        <div className="flex flex-wrap justify-center mt-6 text-sm text-[#6b5d4f] font-medium gap-[8px]" data-id="element-203">
          <span className="flex items-center gap-1.5" data-id="element-204">
            <Shield size={16} className="text-[#c9a961]" data-id="element-205" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-206">
            <Lock size={16} className="text-[#c9a961]" data-id="element-207" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-208">
            <CreditCard size={16} className="text-[#c9a961]" data-id="element-209" /> Mercado Pago
          </span>
        </div>
      </motion.div>
    </section>;
}